export const en: Record<string, string> = {
  "wallet.description": "Your balance, awarded contracts, escrow funding, and milestone releases.",
  "wallet.earnings": "View earnings",
  "wallet.available": "Available balance",
  "wallet.cashIn": "Cash In",
  "wallet.cashOut": "Cash Out",
  "wallet.tile.escrow": "In Escrow",
  "wallet.tile.escrowHint": "Funds you're holding for providers",
  "wallet.tile.released": "Released",
  "wallet.tile.releasedHint": "Total you've paid out",
  "wallet.tile.earned": "Earned",
  "wallet.tile.earnedHint": "Released to you as a provider",
  "wallet.tile.incoming": "Incoming",
  "wallet.tile.incomingHint": "Held in escrow for your work",
  "wallet.contracts": "Contracts",
  "wallet.contractsDescription": "Awarded contracts, escrow funding, milestone releases and signatures now have their own page.",
  "wallet.viewContracts": "View contracts →",
  "wallet.mobile.viewContracts": "View contracts",
  "wallet.mobile.hideBalance": "Hide balance",
  "wallet.mobile.showBalance": "Show balance",
  "wallet.mobile.downloadStatement": "Download Statement",
  "wallet.mobile.statementUnavailable": "Wallet statements are not available yet.",
  "wallet.cash.close": "Close cash panel",
  "wallet.cash.inSubtitle": "Add funds with",
  "wallet.cash.outSubtitle": "Transfer to a bank or e-wallet",
  "wallet.cash.amountIn": "Amount to add",
  "wallet.cash.amountOut": "Amount to withdraw",
  "wallet.cash.min": "Min.",
  "wallet.cash.max": "Max.",
  "wallet.cash.suggested": "Suggested amounts",
  "wallet.cash.paymentMethod": "Payment method",
  "wallet.cash.card": "Card",
  "wallet.cash.qrTitle": "Pay from your bank or e-wallet",
  "wallet.cash.cardTitle": "Debit or credit card",
  "wallet.cash.qrDescription": "Scan a QR code with your supported payment app.",
  "wallet.cash.cardDescription": "Complete your payment in secure GMPay checkout.",
  "wallet.cash.continueQR": "Continue with QRPH",
  "wallet.cash.continueCard": "Continue with card",
  "wallet.cash.poweredBy": "Powered by",
  "wallet.cash.available": "Available to cash out",
  "wallet.cash.transferTo": "Transfer to",
  "wallet.cash.bank": "Bank or e-wallet",
  "wallet.cash.chooseBank": "Choose a destination",
  "wallet.cash.account": "Account or mobile number",
  "wallet.cash.receiver": "Receiver name",
  "wallet.cash.review": "Review cash out",
  "wallet.cash.withdraw": "Confirm withdrawal",
  "wallet.cash.processing": "Processing…",
  "wallet.cash.edit": "Edit details",
  "wallet.cash.fromWallet": "From your KontrataPH wallet",
  "wallet.cash.destination": "Destination",
  "wallet.cash.reservedNotice": "Funds are reserved while GMPay processes a withdrawal.",
  "wallet.cash.amountError": "Enter a whole-peso amount within the displayed limits.",
  "wallet.cash.balanceError": "Amount exceeds your available balance.",
  "wallet.cash.destinationError": "Select a destination bank or e-wallet.",
  "wallet.cash.receiverError": "Enter the account number and receiver name.",
  "wallet.cash.inError": "Cash-in failed. Please try again.",
  "wallet.cash.outError": "Cash-out failed. Please try again.",
  "transaction.placeOrder": "Place Order",
  "transaction.contract": "Contract",
  "transaction.signContract": "Sign Contract",
  "transaction.milestone": "Milestone",
  "transaction.milestones": "Milestones",
  "transaction.status.completed": "Completed",
  "transaction.status.cancelled": "Cancelled",
  "transaction.wallet": "Wallet",
  "transaction.balance": "Balance",
  "transaction.history": "Recent transactions",
  "transaction.earnings": "Earnings",
};

export const tl: Record<string, string> = {
  "wallet.description": "Balanse mo, mga iginawad na kontrata, pondong escrow, at mga inilabas na bayad sa yugto.",
  "wallet.earnings": "Tingnan ang mga kita",
  "wallet.available": "Magagamit na balanse",
  "wallet.cashIn": "Mag-cash In",
  "wallet.cashOut": "Mag-cash Out",
  "wallet.tile.escrow": "Nasa Escrow",
  "wallet.tile.escrowHint": "Pondong hawak mo para sa mga provider",
  "wallet.tile.released": "Inilabas",
  "wallet.tile.releasedHint": "Kabuuang naibayad mo",
  "wallet.tile.earned": "Kinita",
  "wallet.tile.earnedHint": "Inilabas sa iyo bilang provider",
  "wallet.tile.incoming": "Papasok",
  "wallet.tile.incomingHint": "Naka-escrow para sa trabaho mo",
  "wallet.contracts": "Mga Kontrata",
  "wallet.contractsDescription": "May sarili nang pahina ang mga iginawad na kontrata, pondong escrow, bayad sa yugto, at mga lagda.",
  "wallet.viewContracts": "Tingnan ang mga kontrata →",
  "wallet.mobile.viewContracts": "Tingnan ang mga kontrata",
  "wallet.mobile.hideBalance": "Itago ang balanse",
  "wallet.mobile.showBalance": "Ipakita ang balanse",
  "wallet.mobile.downloadStatement": "I-download ang Statement",
  "wallet.mobile.statementUnavailable": "Hindi pa available ang wallet statement.",
  "wallet.cash.close": "Isara ang cash panel",
  "wallet.cash.inSubtitle": "Magdagdag ng pondo gamit ang",
  "wallet.cash.outSubtitle": "Ilipat sa bangko o e-wallet",
  "wallet.cash.amountIn": "Halagang idaragdag",
  "wallet.cash.amountOut": "Halagang iwi-withdraw",
  "wallet.cash.min": "Min.",
  "wallet.cash.max": "Max.",
  "wallet.cash.suggested": "Mga mungkahing halaga",
  "wallet.cash.paymentMethod": "Paraan ng pagbabayad",
  "wallet.cash.card": "Card",
  "wallet.cash.qrTitle": "Magbayad mula sa bangko o e-wallet",
  "wallet.cash.cardTitle": "Debit o credit card",
  "wallet.cash.qrDescription": "I-scan ang QR code gamit ang suportadong payment app.",
  "wallet.cash.cardDescription": "Kumpletuhin ang bayad sa secure na GMPay checkout.",
  "wallet.cash.continueQR": "Magpatuloy gamit ang QRPH",
  "wallet.cash.continueCard": "Magpatuloy gamit ang card",
  "wallet.cash.poweredBy": "Pinapagana ng",
  "wallet.cash.available": "Maaaring i-cash out",
  "wallet.cash.transferTo": "Ilipat sa",
  "wallet.cash.bank": "Bangko o e-wallet",
  "wallet.cash.chooseBank": "Pumili ng destinasyon",
  "wallet.cash.account": "Account o mobile number",
  "wallet.cash.receiver": "Pangalan ng tatanggap",
  "wallet.cash.review": "Suriin ang cash out",
  "wallet.cash.withdraw": "Kumpirmahin ang withdrawal",
  "wallet.cash.processing": "Pinoproseso…",
  "wallet.cash.edit": "Baguhin ang detalye",
  "wallet.cash.fromWallet": "Mula sa iyong KontrataPH wallet",
  "wallet.cash.destination": "Destinasyon",
  "wallet.cash.reservedNotice": "Nakalaan ang pondo habang pinoproseso ng GMPay ang withdrawal.",
  "wallet.cash.amountError": "Maglagay ng buong halagang piso na pasok sa mga limitasyon.",
  "wallet.cash.balanceError": "Lampas ang halaga sa iyong magagamit na balanse.",
  "wallet.cash.destinationError": "Pumili ng bangko o e-wallet na tatanggap.",
  "wallet.cash.receiverError": "Ilagay ang account number at pangalan ng tatanggap.",
  "wallet.cash.inError": "Hindi nagtagumpay ang cash in. Subukan muli.",
  "wallet.cash.outError": "Hindi nagtagumpay ang cash out. Subukan muli.",
  "transaction.placeOrder": "Mag-order",
  "transaction.contract": "Kontrata",
  "transaction.signContract": "Lagdaan ang Kontrata",
  "transaction.milestone": "Yugto ng Trabaho",
  "transaction.milestones": "Mga Yugto ng Trabaho",
  "transaction.status.completed": "Nakumpleto",
  "transaction.status.cancelled": "Kinansela",
  "transaction.wallet": "Wallet",
  "transaction.balance": "Balanse",
  "transaction.history": "Kasaysayan ng mga Transaksyon",
  "transaction.earnings": "Mga Kita",
};
